/**
 * http://usejsdoc.org/
 */
import { create } from 'apisauce';


// define the api

var api ;
const func = {};
func.setApi = () => {
	if (window.ENV) {
		api = create({
			baseURL: window.ENV?.terminalApiUrl
		  });
	}
}
const _formPostBody = (transactionType, amount) => {
	var type;
	// console.log(transactionType);
	if(transactionType === "Credit"){
		type = 'CCR1'
	}
	else if(transactionType === "Debit"){
		type = 'DB00'
	}
	var bodyString = `<DETAIL>
					     <TRAN_TYPE>${type}</TRAN_TYPE>
	                     <AMOUNT>${amount}</AMOUNT>
	                  </DETAIL>`;
	return bodyString;
}

func.AuthorizeAndCapture = (transactionType, amount) => {
	// console.log(api.getBaseURL());
	// console.log('in terminal authorize and capture');
	// console.log(transactionType,amount)
	var postBody = _formPostBody(transactionType, amount);
	// console.log(postBody);
	api.setHeader('Content-Type', 'text/plain');

	process.env.NODE_TLS_REJECT_UNAUTHORIZED = '0';
	return api.post('', postBody);
}

export default func;